import React from "react";
import _ from "lodash";
import { Box, Button } from "@showitinc/showit-wc";
import Immutable from "immutable";
import Modal from "../base/Modal";
import ButtonBar from "../base/ButtonBar";
import LinkProperties, { MODE_ELEMENT } from "../LinkProperties";
import LinkWarning from "../editor/LinkWarning";
import BlockUpdateVO from "../../vo/BlockUpdate.mjs";
import uiPrefix from "../../utils/UiPrefixUtils";
import DocumentStore from "../../document/DocumentStore";
import { COMMANDS } from "../../document/commands";
import DataTypes from "@/constants/DataTypes";
import IDUtils from "@/utils/IDUtils";
import { generateCleanActionUpdates } from "@/utils/GroupUtils";

class ElementLinkModal extends React.Component {
  state = {
    linkConfig: Immutable.fromJS({ link: {} }),
    update: new BlockUpdateVO(),
  };

  // cleans child data on set
  _cleanChildData = () => {
    if (!this.state.update.updates.length) return;
    this.props.selectedElements.forEach((element) => {
      // remove grouped element action and link data on change
      if (element.type === DataTypes.GROUP) {
        const innerPath = IDUtils.getArray(element.id, 1);
        const container = this.props.block.getIn(innerPath);
        const updates = generateCleanActionUpdates(container, element.id);
        Object.entries(updates).forEach(([key, childElementUpdates]) =>
          childElementUpdates.forEach((update) => this.state.update.addPropUpdate(key, update))
        );
      }
    });
  };

  _save = () => {
    this._cleanChildData();

    DocumentStore.dispatch({ type: COMMANDS.UPDATE_BLOCK, payload: this.state.update });
    this.props.onHide();
  };

  _addBlockUpdate = (addMe) => {
    this.props.selectedElements
      .toArray()
      .forEach((selected) => this.state.update.addPropUpdate(selected.id, addMe));
  };

  _updateLinkConfig = (propInfo) => {
    let nameParts = propInfo.name.split(".");
    let linkConfig = this.state.linkConfig;

    if (propInfo.name === "link") {
      if (propInfo.value == null) {
        linkConfig = linkConfig.clear();
      } else {
        linkConfig = linkConfig.mergeIn(nameParts, propInfo.value);
      }
    } else {
      if (_.isEmpty(propInfo.value) && !_.isNumber(propInfo.value)) {
        linkConfig = linkConfig.deleteIn(nameParts, propInfo.value);
      } else {
        linkConfig = linkConfig.setIn(nameParts, propInfo.value);
      }
    }

    this.setState({ linkConfig });
  };

  _onLinkChange = (propInfo) => {
    this._updateLinkConfig(propInfo);
    this._addBlockUpdate(propInfo);
  };

  render() {
    let modalProps = _.pick(this.props, Modal.BASIC_PROPS);
    let { linkWarningEnabled } = this.props;
    let link = this.state.linkConfig.get("link");

    let linkWarning = linkWarningEnabled ? <LinkWarning /> : null;

    return (
      <Modal {...modalProps}>
        <Modal.Dialog size="small">
          <Modal.Dialog.Header closeButton>
            <Modal.Dialog.Title>Link</Modal.Dialog.Title>
          </Modal.Dialog.Header>
          <Modal.Dialog.Body style={{ overflow: "hidden" }}>
            {linkWarning}
            <LinkProperties mode={MODE_ELEMENT} link={link} onPropUpdate={this._onLinkChange} />
          </Modal.Dialog.Body>
          <Modal.Dialog.Footer>
            <ButtonBar>
              <Box mr="3">
                <Button
                  variant="minimal"
                  data-e2e={uiPrefix("modal-cancel-btn")}
                  className={uiPrefix("modal-cancel-btn")}
                  onClick={this.props.onHide}
                >
                  Cancel
                </Button>
              </Box>
              <Button
                variant="feature"
                data-e2e={uiPrefix("modal-save-btn")}
                className={uiPrefix("modal-save-btn")}
                onClick={this._save}
              >
                Save
              </Button>
            </ButtonBar>
          </Modal.Dialog.Footer>
        </Modal.Dialog>
      </Modal>
    );
  }
}

export default ElementLinkModal;
